export const LOGOUT_BROADCAST_CHANNEL_NAME = 'empLogoutChannel';
